import React, { useState } from "react";
import { Link } from "gatsby";

export const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="px-4 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
      <div className="relative flex items-center justify-between">
        <Link
          to="/"
          aria-label="Rupiah.Trade"
          title="Rupiah.Trade"
          className="inline-flex items-center"
        >
          <Logo />
        </Link>

        <ul className="items-center hidden space-x-8 lg:flex">
          <li>
            <a
              href="/#feature"
              aria-label="Fitur"
              title="Fitur"
              className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary-700"
            >
              Fitur
            </a>
          </li>
          <li>
            <a
              href="/#how"
              aria-label=" Cara Kerja"
              title=" Cara Kerja"
              className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary-700"
            >
              Cara Kerja
            </a>
          </li>
          <li>
            <a
              href="/#rate"
              aria-label="Rate"
              title="Rate"
              className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary-700"
            >
              Rate
            </a>
          </li>
          <li>
            <a
              href="/#faq"
              aria-label="FAQ"
              title="FAQ"
              className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary-700"
            >
              FAQ
            </a>
          </li>
          <li>
            <Link
              to="/testimonial"
              aria-label=" Testimoni"
              title="Testimoni"
              className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary-700"
            >
              Testimoni
            </Link>
          </li>
          <li>
            <a
              href="https://app.rupiah.trade"
              className="inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded-full shadow-xl bg-primary-700 hover:bg-primary-500 hover:shadow-2xl focus:shadow-outline focus:outline-none"
              aria-label="Tukar Sekarang"
              title="Tukar Sekarang"
            >
              Tukar Sekarang
            </a>
          </li>
        </ul>
        <div className="lg:hidden">
          <button
            aria-label="Open Menu"
            title="Open Menu"
            className="p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline hover:bg-primary-50 focus:bg-primary-50"
            onClick={() => setIsMenuOpen(true)}
          >
            <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
              />
              <path
                fill="currentColor"
                d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
              />
              <path
                fill="currentColor"
                d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
              />
            </svg>
          </button>

          {isMenuOpen && (
            <div className="absolute top-0 left-0 w-full z-50">
              <div className="p-5 bg-white rounded-2xl shadow-xl">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <Link
                      to="/"
                      aria-label="Rupiah.Trade"
                      title="Rupiah.Trade"
                      className="inline-flex items-center"
                    >
                      <Logo />
                    </Link>
                  </div>
                  <div>
                    <button
                      aria-label="Close Menu"
                      title="Close Menu"
                      className="p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <nav>
                  <ul className="space-y-4">
                    <li>
                      <a
                        href="/#feature"
                        aria-label=" Fitur"
                        title=" Fitur"
                        className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary-700"
                      >
                        Fitur
                      </a>
                    </li>
                    <li>
                      <a
                        href="/#how"
                        aria-label="Cara Kerja"
                        title="Cara Kerja"
                        className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary-700"
                      >
                        Cara Kerja
                      </a>
                    </li>
                    <li>
                      <a
                        href="/#rate"
                        aria-label="Rate"
                        title="Rate"
                        className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary-700"
                      >
                        Rate
                      </a>
                    </li>
                    <li>
                      <a
                        href="/#faq"
                        aria-label="FAQ"
                        title="FAQ"
                        className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary-700"
                      >
                        FAQ
                      </a>
                    </li>
                    <li>
                      <Link
                        to="/testimonial"
                        aria-label="Testimoni"
                        title="Testimoni"
                        className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary-700"
                      >
                        Testimoni
                      </Link>
                    </li>
                    <li>
                      <a
                        href="https://app.rupiah.trade"
                        className="inline-flex items-center justify-center w-full h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded-full shadow-xl bg-primary-700 hover:bg-primary-500 hover:shadow-2xl focus:shadow-outline focus:outline-none"
                        aria-label="Sign up"
                        title="Sign up"
                      >
                        Tukar Sekarang
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Nav;

const Logo = () => (
  <svg
    className="h-12 lg:h-14"
    viewBox="0 0 100 40"
    strokeLinejoin="round"
    strokeWidth="2"
    strokeLinecap="round"
    strokeMiterlimit="10"
    fill="currentColor"
    role="img"
  >
    <circle cx="18.7" cy="20" r="18.7" fill="#7B00FF" />
    <path
      fill="#FFF"
      d="M26.3 19.4A2.3 2.3 0 0 1 24 17c0-3.1-2.4-5.5-5.5-5.5S13 14 13 17v9.8h5.5c1.3 0 2.3 1.1 2.3 2.4s-1 2.4-2.3 2.4H8.3V17c0-5.7 4.5-10.3 10.1-10.3S28.6 11.4 28.6 17c0 1.3-1 2.4-2.3 2.4z"
    />
    <ellipse cx="25.6" cy="25.3" fill="#F2CB3C" rx="3.4" ry="3.5" />
    <g fill="#F2CB3C">
      <ellipse cx="78" cy="5.9" rx="1.2" ry="1.3" />
      <ellipse cx="43.1" cy="33.6" rx="1.2" ry="1.3" />
    </g>
    <path
      fill="#7B00FF"
      d="M78.6 8.6c.2.2.2.4.2.7V17l-.2.7-.6.3c-.3 0-.5-.1-.6-.3-.2-.2-.2-.4-.2-.7V9.3c0-.3.1-.5.3-.7l.6-.3.5.3zm-26.5 8.6-.5-.9-.2-1.6-.1-.8-.4-.5-.6-.3-.7-.1h-3.5v4l-.2.7c-.1.2-.3.3-.6.3a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7V6.2c0-.3.1-.5.3-.7l.6-.3h5a4 4 0 0 1 1.8.5c.5.3 1 .8 1.3 1.3.3.6.5 1.2.5 1.9 0 .5-.1.9-.3 1.4-.2.4-.4.8-.8 1.1-.2.3-.5.5-.8.6l.5.4c.3.2.5.5.6.9.2.3.2.7.3 1.1l.1.9.1.6.3.4.4.5c.1.2 0 .5-.2.6l-.4.3h-.5l-.4-.1c-.2 0-.4-.2-.6-.4zm-.3-8.1a2 2 0 0 0-.5-1.4c-.4-.5-.8-.7-1.2-.7h-3.9v4.4h4c.3 0 .5-.1.8-.3.2-.2.5-.5.6-.9l.2-1.1zm8 8.9c1.2 0 2.2-.3 2.9-1 .7-.7 1-1.7 1-2.9V9.3a1 1 0 0 0-.3-.7l-.6-.3c-.3 0-.5.1-.6.3-.2.3-.2.5-.2.7V14c0 .8-.2 1.4-.5 1.7-.4.4-.9.6-1.6.6-.7 0-1.2-.2-1.6-.6-.4-.4-.5-1-.5-1.7V9.3a1 1 0 0 0-.3-.7l-.6-.3c-.3 0-.5.1-.6.3a1 1 0 0 0-.3.7V14c0 1.2.3 2.2 1 2.9.6.8 1.6 1.1 2.8 1.1zm11.1 0-1.3-.2c-.4-.1-.8-.3-1.1-.6l-.6-.6v3.9c0 .3-.1.5-.3.7l-.6.3c-.3 0-.5-.1-.6-.3a1 1 0 0 1-.3-.7V9.3c0-.3.1-.5.3-.6l.6-.3c.2 0 .5.1.6.3.3.1.4.4.4.6v.4l.1-.1.7-.7 1-.5 1.2-.2a4 4 0 0 1 2.2.6c.6.4 1.2 1 1.5 1.7.4.7.6 1.6.6 2.5a5 5 0 0 1-2.1 4.2c-.7.6-1.5.8-2.3.8zm-.2-1.6c.6 0 1-.1 1.4-.4a4 4 0 0 0 1-1.2c.2-.5.4-1 .4-1.7 0-.6-.1-1.2-.4-1.6-.2-.5-.6-.9-1-1.1-.4-.3-.9-.4-1.4-.4-.6 0-1.1.1-1.5.4l-1 1.1c-.2.5-.4 1-.4 1.7 0 .6.1 1.2.4 1.7.2.5.6.9 1 1.2.4.1.9.3 1.5.3zm18.8-7.8c.2.2.2.4.2.7V17l-.2.7-.6.3c-.3 0-.5-.1-.6-.3-.3-.3-.3-.5-.3-.7v-.3l-.6.6-1 .6c-.4.2-.8.2-1.3.2-.8 0-1.5-.2-2.2-.6-.6-.4-1.2-1-1.5-1.7-.4-.7-.6-1.6-.6-2.5A5 5 0 0 1 82.9 9a4 4 0 0 1 2.1-.6c.5 0 1 .1 1.4.3l1.1.6.5.4v-.5c0-.2 0-.5.2-.6l.6-.3c.3 0 .5.1.7.3zM88 13.1c0-.6-.1-1.2-.4-1.7a3 3 0 0 0-1-1.2c-.4-.3-.9-.4-1.5-.4-.5 0-1 .1-1.4.4a4 4 0 0 0-1 1.2c-.2.5-.4 1-.4 1.7 0 .6.1 1.2.4 1.7.2.5.6.9 1 1.2.4.3.9.4 1.4.4.6 0 1-.1 1.5-.4a3 3 0 0 0 1-1.2c.3-.5.4-1.1.4-1.7zm11.7-2.9c-.2-.6-.5-1.1-.9-1.4-.4-.4-1.1-.5-1.9-.5l-1.1.2-1 .5-.7.8-.1.1V5.5a1 1 0 0 0-.3-.7l-.6-.3c-.3 0-.5.1-.6.3a1 1 0 0 0-.3.7V17c0 .3.1.5.3.7l.6.3c.2 0 .5-.1.6-.3.2-.2.3-.4.3-.7v-4.8c0-.4.1-.8.3-1.1l.8-.8 1.2-.3c.5 0 .9.1 1.1.3.3.2.5.5.6.8l.2 1.1V17c0 .3.1.5.3.7l.6.3c.2 0 .5-.1.6-.3.2-.2.3-.4.3-.7v-4.8c0-.7-.1-1.4-.3-2zM49.3 27l.6-.2c.2-.2.2-.4.2-.6l-.2-.6c-.2-.2-.4-.2-.6-.2h-1.4V24l-.2-.7a1 1 0 0 0-.7-.3c-.2 0-.5.1-.6.3a1 1 0 0 0-.3.7v1.4h-1l-.6.2c-.2.2-.2.4-.2.6l.2.6c.2.2.4.2.6.2h1v5.3c0 .6.1 1 .3 1.3l.6.7.8.3.7.1c.4 0 .7-.1 1-.3.3-.2.5-.4.5-.7l-.2-.5c-.1-.2-.3-.2-.4-.2H49l-.3.1-.4-.1-.3-.3-.1-.5V27h1.4zm8.3-1.7c-.2-.2-.5-.3-.8-.3l-1.1.2-.9.5-.7.8-.3.5v-.8a1 1 0 0 0-.3-.7l-.6-.3c-.3 0-.5.1-.6.3a1 1 0 0 0-.3.7v7.6c0 .3.1.5.3.7l.6.3c.2 0 .5-.1.6-.3.2-.2.3-.4.3-.7v-4.3l.2-1.2.5-.9c.2-.3.4-.5.7-.6l.8-.2.6.1.5.1.5-.2c.2-.1.2-.4.2-.7.1-.3 0-.5-.2-.6zm10 0c.2.2.2.4.2.7v7.8l-.2.7-.6.3c-.3 0-.5-.1-.6-.3-.3-.3-.4-.5-.4-.7v-.3l-.6.6-1 .6c-.4.2-.8.2-1.3.2-.8 0-1.5-.2-2.2-.6-.6-.4-1.2-1-1.5-1.7-.4-.7-.6-1.6-.6-2.5a5 5 0 0 1 2.1-4.3 4 4 0 0 1 2.1-.6c.5 0 1 .1 1.4.3l1.1.6.5.4V26l.2-.6.6-.3.8.2zm-1.5 4.6c0-.6-.1-1.2-.4-1.7a3 3 0 0 0-1-1.2c-.4-.3-.9-.4-1.5-.4-.5 0-1 .1-1.4.4a4 4 0 0 0-1 1.2c-.2.5-.4 1-.4 1.7 0 .6.1 1.2.4 1.7.2.5.6.9 1 1.2.4.3.9.4 1.4.4.6 0 1-.1 1.5-.4a3 3 0 0 0 1-1.2c.3-.5.4-1.1.4-1.7zm12.4-8.3c.2.2.2.4.2.7v11.4l-.2.7-.6.3c-.3 0-.5-.1-.6-.3l-.3-.6v-.4l-.6.6-1 .6c-.4.2-.8.2-1.3.2-.8 0-1.5-.2-2.2-.6-.6-.4-1.2-1-1.5-1.7-.4-.7-.6-1.6-.6-2.5a5 5 0 0 1 2.1-4.2 4 4 0 0 1 2.1-.6c.5 0 1 .1 1.4.3l1.1.6.5.4v-4.1l.2-.7.6-.3c.4 0 .6.1.7.2zm-1.4 8.3c0-.6-.1-1.2-.4-1.7a3 3 0 0 0-1-1.2c-.4-.3-.9-.4-1.5-.4-.5 0-1 .1-1.4.4a4 4 0 0 0-1 1.2c-.2.5-.4 1-.4 1.7 0 .6.1 1.2.4 1.7.2.5.6.9 1 1.2.4.3.9.4 1.4.4.6 0 1.1-.1 1.5-.4a4 4 0 0 0 1-1.2c.3-.5.4-1 .4-1.7zm12.1-2.1c.2.6.4 1.2.4 1.8l-.3.6c-.2.2-.4.2-.6.2h-6.1l.4 1.2c.3.5.6.9 1.1 1.1.5.3 1 .4 1.5.4l1.1-.1.7-.3.5-.4.5-.2.5.2.2.5c0 .3-.1.5-.4.7l-1.3.8c-.6.2-1.1.4-1.8.4-1 0-1.8-.2-2.5-.6a4.6 4.6 0 0 1-2.3-4.1c0-1.1.2-2 .6-2.7.4-.7 1-1.3 1.6-1.7a4.2 4.2 0 0 1 3.7-.3 5.8 5.8 0 0 1 2.5 2.5zm-1.5 1a2.1 2.1 0 0 0-1.3-1.8c-.4-.2-.7-.3-1.1-.3l-1 .2-.9.5a2 2 0 0 0-.6 1l-.1.5h5.1v-.1z"
    />
  </svg>
);
